import type { EmptyResponse } from '@luna/api';
import { createMutation, request } from '@luna/api';

import { getBankMessageUrl } from './BankMessagesService';

export const [useMarkBankMessagesAsRead] = createMutation<undefined, string[]>({
    name: 'bank-messages/mark-messages-read',
    payloadCreator: async (messagesIds) => {
        await Promise.all(
            messagesIds.map((id) =>
                request.put<EmptyResponse>(getBankMessageUrl(id), { read: true }),
            ),
        );

        return undefined;
    },
});
